import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {green, red} from '@material-ui/core/colors';
import createMuiTheme from '@material-ui/core/styles/createTheme';
import {CheckCircle, Error} from '@material-ui/icons';
import {PropTypes} from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

const theme = createMuiTheme();

const styles = {
  list: {
    backgroundColor: theme.palette.background.default,
    width: 500,
    marginTop: 20
  }
};

/* eslint-disable max-lines-per-function */
// eslint-disable-next-line require-jsdoc
export default function DocumentValidation(props) {
  return (
    <div style={styles.list}>
      <List dense={true}>
        <ListItem>
          <ListItemText primary={locale.compliant} />
          <ListItemIcon>
            {props.validationResult.info.compliant && (
              <CheckCircle style={{color: green[500]}} />
            )}
            {!props.validationResult.info.compliant && (
              <Error style={{color: red[500]}} />
            )}
          </ListItemIcon>
        </ListItem>
        {!props.profileMode && (
          <ListItem>
            <ListItemText primary={locale.cantonalSealSignatureValid} />
            <ListItemIcon>
              {props.validationResult.info.cantonalSealSignatureValid &&
                props.validationResult.error !==
                  'ERROR_NOTARY_DOCUMENT_INVALID_CANTONAL_SEAL' && (
                  <CheckCircle style={{color: green[500]}} />
                )}
              {(!props.validationResult.info.cantonalSealSignatureValid ||
                props.validationResult.error ===
                  'ERROR_NOTARY_DOCUMENT_INVALID_CANTONAL_SEAL') && (
                <Error style={{color: red[500]}} />
              )}
            </ListItemIcon>
          </ListItem>
        )}
        <ListItem>
          <ListItemText primary={locale.notarySignatureValid} />
          <ListItemIcon>
            {props.validationResult.info.notarySignatureValid && (
              <CheckCircle style={{color: green[500]}} />
            )}
            {!props.validationResult.info.notarySignatureValid && (
              <Error style={{color: red[500]}} />
            )}
          </ListItemIcon>
        </ListItem>
      </List>
    </div>
  );
}

DocumentValidation.propTypes = {
  validationResult: PropTypes.object,
  profileMode: PropTypes.bool
};
